import { amountToPriceString } from '@caterdesk/utils--money'
import { Box, Typography } from '@mui/material'

import type React from 'react'

type Props = {
  currency: string
  price: number
  priceCaveat: string
  taxAcronym: string
  compact?: boolean
  align?: 'left' | 'right'
  inline?: boolean
}

export const ItemPrice: React.FC<Props> = ({
  currency,
  price,
  priceCaveat,
  taxAcronym,
  compact = false,
  align = 'right',
  inline = false,
}) => (
  <Box
    sx={
      inline
        ? {
            display: 'flex',
            alignItems: 'baseline',
            gap: 0.5,
            justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
          }
        : undefined
    }>
    <Typography variant={compact ? 'subtitle3' : 'h6'} textAlign={align}>
      {amountToPriceString(currency, price.toString(), true)} {priceCaveat}
    </Typography>
    <Typography variant="body3" color="text.secondary" textAlign={align} fontWeight={600}>
      (ex {taxAcronym})
    </Typography>
  </Box>
)
